import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicorporate() {



  const cardData =
  {
    keyword: 'Pune to Shirdi Corporate Cab Booking',
    heading: 'Aaryan Travels: Pune to Shirdi Corporate Cab Booking',
    headingDescription: ' Aaryan Travels offers seamless Pune to Shirdi Corporate Cab Booking for business delegations, company executives, and official visits to the revered Sai Baba Temple. Whether it’s a corporate pilgrimage, client travel, or VIP guest transfer, our premium sedans, SUVs, and luxury cabs provide a safe and comfortable ride with professional chauffeurs and on-time service. We offer flexible one-way or round-trip options with invoicing support, GPS-enabled vehicles, and assured cleanliness for dignified travel. With 24/7 availability and pickup from any corporate zone in Pune—Hinjewadi, Kharadi, Magarpatta, Pimpri-Chinchwad, or Pune Airport—Aaryan Travels ensures a smooth and reliable cab booking experience for corporate trips from Pune to Shirdi.',

    top: 'Top Places to Visit in Shirdi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "The Shirdi Sai Baba Temple is the main pilgrimage site dedicated to Sai Baba, attracting millions of devotees each year. The temple houses the sacred Samadhi Mandir where Sai Baba’s mortal remains are enshrined. Daily aarti rituals create a powerful devotional atmosphere. Devotees line up with utmost faith, seeking blessings and peace. The temple is the spiritual heart of Shirdi."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai Masjid is the holy place where Sai Baba spent a significant part of his life guiding devotees. Inside, the eternal sacred fire (dhuni) still burns, and its ash is believed to have healing powers. The stone walls reflect simplicity and divinity. People sit silently, feeling the saint’s presence. Dwarkamai is Shirdi’s symbol of grace and protection."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning ‘Seat of the Guru’, is where Sai Baba was first seen meditating under a neem tree. A shrine stands here today with an idol and sacred incense burners. Devotees believe lighting incense fulfills their wishes. The neem leaves are also considered holy prasad. Gurusthan marks the beginning of Sai Baba’s journey in Shirdi."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the place where Sai Baba used to rest every alternate night in his later years. The tradition is still honored through the famous Thursday Palkhi procession where Baba’s idol is taken from Dwarkamai to Chavadi. Original bedding, seat, and historical objects are preserved inside. Chavadi keeps alive the rituals of Sai Baba’s time."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Located around 70 km from Shirdi, Shani Shingnapur is a unique village where houses have no doors or locks. The open-air shrine is dedicated to Lord Shani (Saturn), and people come here to seek protection from troubles and bad luck. It is believed that Lord Shani personally guards the village. Shani Shingnapur is Shirdi’s most visited spiritual extension."
  },
  {
    "title": "Sai Heritage Village & Theme Park",
    "description": "Sai Heritage Village is a creative theme park that showcases life scenes of Sai Baba through statues and installations. Families enjoy ropeway rides, adventure zones, and village-style settings. It blends devotion with recreation, making it popular among children. Green landscapes and traditional ambiance enhance the experience. It is Shirdi’s devotional picnic spot."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden where Sai Baba used to water plants and meditate daily. A small deep (lamp) lit by Baba is still kept burning inside a small shrine. The lush greenery and quiet surroundings provide a calming escape for devotees. The pathways are ideal for contemplation. Lendi Baug is Shirdi’s serene spiritual retreat."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is the first place where Sai Baba was greeted when he arrived in Shirdi. Priest Mhalsapati welcomed him with the words ‘Aao Sai’, which led to his name. The temple is dedicated to Lord Khandoba, a form of Shiva, and holds immense historical and spiritual importance. It is Shirdi’s gateway of divine welcome."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy is a fun-filled water park close to the temple area, offering thrilling rides, wave pools, and rain dance zones. It provides a refreshing break for families after temple visits. Clean facilities and food counters make it comfortable for all ages. The park is especially popular among children. Wet N Joy is Shirdi’s joyful recreation zone."
  },
  {
    "title": "Prasadalaya",
    "description": "Prasadalaya is the massive dining hall run by the Shirdi Sansthan, serving free or low-cost meals to thousands of devotees daily. The food is prepared with hygiene and devotion. Eating together in large halls creates a feeling of unity and humility. Volunteers serve with a smile. Prasadalaya reflects Shirdi’s values of service and equality."
  }
],


"services": [
  {
    "name": "Pune to Shirdi Corporate Cab Booking",
    "description": "Book hassle-free Pune to Shirdi Corporate Cabs tailored for business travel, employee commutes, and executive transfers. Our professional-grade service ensures timely pickups, clean and comfortable vehicles, and courteous chauffeurs who understand the importance of punctuality and professionalism. Ideal for companies arranging religious or industrial visits, this service includes centralized billing, GPS tracking, and flexible scheduling options."
  },
  {
    "name": "Corporate Taxi Pune Shirdi",
    "description": "Our Corporate Taxi service from Pune to Shirdi caters to executives, staff, and business visitors who require reliable and comfortable long-distance travel. Featuring well-maintained sedans and SUVs, we provide trained drivers, smooth route management, and customer support for corporate clients. The service is optimized for convenience, with online booking, billing, and support for one-way or round trips."
  },
  {
    "name": "Business Cab Pune to Shirdi",
    "description": "Choose our Business Cab service for travel between Pune and Shirdi to give your employees or business guests a seamless experience. Whether it’s for factory visits, temple tours, or field inspections, our cabs offer executive seating, corporate-grade amenities, and on-time performance. It’s the ideal solution for productivity on the move."
  },
  {
    "name": "Chauffeur Corporate Cab Pune to Shirdi",
    "description": "Enjoy a premium ride with our Chauffeur-driven Corporate Cabs from Pune to Shirdi. Our chauffeurs are trained in corporate etiquette, route safety, and long-distance driving, ensuring a relaxing and safe journey. These cabs are perfect for high-level executives or VIP guests who demand professionalism and comfort in every detail."
  },
  {
    "name": "Office Cab Pune Shirdi",
    "description": "Our Office Cab service from Pune to Shirdi provides safe and efficient transportation for office teams and groups. Whether for team outings, CSR activities, or employee spiritual visits, we offer spacious vehicles, professional drivers, and full journey coordination, all managed under a corporate travel policy framework."
  },
  {
    "name": "Outstation Corporate Cab Pune Shirdi",
    "description": "Travel from Pune to Shirdi with confidence using our Outstation Corporate Cab service, ideal for long-distance business travel. With AC-equipped cabs, verified drivers, and strict adherence to timelines, we make corporate intercity travel comfortable and dependable. Options available for one-way, round-trip, or multi-day use."
  },
  {
    "name": "Affordable Pune to Shirdi Corporate Taxi",
    "description": "Get the best value without sacrificing service quality with our Affordable Pune to Shirdi Corporate Taxi option. Perfect for startups and growing companies, we offer well-maintained cabs, reliable drivers, and support for group travel — all at cost-effective corporate pricing. Includes monthly billing and service flexibility."
  },
  {
    "name": "Online Corporate Cab Booking Pune Shirdi",
    "description": "Book your corporate cabs online from Pune to Shirdi with ease. Our digital platform allows you to schedule trips, assign employee rides, manage costs, and access billing reports in one place. Get instant confirmation, route tracking, and dedicated support for all your business travel requirements."
  },
  {
    "name": "Staff Transport Pune Shirdi",
    "description": "Ensure timely and safe travel for your employees with our Staff Transport service between Pune and Shirdi. Designed for shift workers and group commutes, our service includes clean, comfortable vehicles, professional drivers, and GPS monitoring. We handle route planning and provide customized packages for recurring travel needs."
  },
  {
    "name": "Premium Corporate Sedan Pune to Shirdi",
    "description": "Upgrade your business travel with our Premium Corporate Sedan service from Pune to Shirdi. Designed for senior executives and special guests, these cabs come with luxurious interiors, silent cabins, air conditioning, and trained chauffeurs. Ideal for those who require comfort and a touch of sophistication on the road."
  },
  {
    "name": "SUV for Corporate Travel Pune Shirdi",
    "description": "Our SUV service for Corporate Travel between Pune and Shirdi offers extra space and enhanced ride quality. Suitable for group travel or executives needing more legroom and luggage space, these vehicles are clean, spacious, and perfect for long-distance business travel with added comfort and utility."
  },
  {
    "name": "Pune to Shirdi Business Travel Cab",
    "description": "Our Business Travel Cab service from Pune to Shirdi is ideal for organizations sending employees, partners, or clients for meetings, events, or religious trips. With comfortable seating, efficient route navigation, and professional drivers, we ensure timely arrivals and safe returns every time."
  },
  {
    "name": "One Way Corporate Cab Pune Shirdi",
    "description": "Save on cost and time with our One Way Corporate Cab service from Pune to Shirdi. Whether your employees or guests are only traveling in one direction, we provide premium vehicles, verified drivers, and flexible pickup timings. Perfect for meetings, temple visits, or field inspections with no return required."
  },
  {
    "name": "Round Trip Cab Pune Shirdi",
    "description": "Opt for our Round Trip Cab service from Pune to Shirdi for complete journey coverage. Perfect for same-day or overnight business travel, our cabs stay with you throughout, ensuring convenience and continuity. Choose from sedans or SUVs, all driven by polite and punctual chauffeurs trained in corporate service."
  },
  {
    "name": "Pune to Shirdi Executive Cab",
    "description": "Our Executive Cab from Pune to Shirdi offers a refined travel experience for corporate leaders and business class professionals. With top-notch vehicles, disciplined chauffeurs, and customizable amenities, your executive team can focus on work or relax en route without any travel-related stress."
  }
],
"tableData": [
  ["Pune to Shirdi Corporate Cab Booking", "Corporate Taxi Pune Shirdi"],
  ["Business Cab Pune to Shirdi", "Chauffeur Corporate Cab Pune to Shirdi"],
  ["Office Cab Pune Shirdi", "Outstation Corporate Cab Pune Shirdi"],
  ["Affordable Pune to Shirdi Corporate Taxi", "Online Corporate Cab Booking Pune Shirdi"],
  ["Staff Transport Pune Shirdi", "Premium Corporate Sedan Pune to Shirdi"],
  ["SUV for Corporate Travel Pune Shirdi", "Pune to Shirdi Business Travel Cab"],
  ["One Way Corporate Cab Pune Shirdi", "Round Trip Cab Pune Shirdi"],
  ["Pune to Shirdi Executive Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Professional Corporate Cab Booking from Pune to Shirdi",
    "WhyChoosedescription": "Aaryan Travels offers dependable corporate cab services for business travel between Pune and Shirdi."
  },
  {
    "WhyChooseheading": "Timely Pickup from Your Office or Location in Pune",
    "WhyChoosedescription": "We ensure prompt pickup and drop-off for a stress-free corporate travel experience to Shirdi."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Our air-conditioned, sanitized cabs like sedans, SUVs, and Innova Crystas offer a smooth and comfortable ride."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our trained drivers are familiar with the Pune-Shirdi route, ensuring timely and efficient travel."
  },
  {
    "WhyChooseheading": "Corporate Billing with Transparent Pricing",
    "WhyChoosedescription": "Get GST-compliant invoices and all-inclusive fares covering fuel, tolls, and driver charges."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Corporate Clients",
    "WhyChoosedescription": "Our customer service is available round the clock to manage your bookings, schedule changes, and support needs."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trip",
    "WhyChoosedescription": "Book a one-way trip or a same-day return as per your corporate travel requirement."
  },
  {
    "WhyChooseheading": "Fleet Suitable for Executives and Teams",
    "WhyChoosedescription": "Choose from executive sedans for individual travel or larger vehicles for small teams and business groups."
  }
]




















  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide corporate cab booking from Pune to Shirdi?',
    answer: 'Yes, Aaryan Travels offers reliable and professional corporate cab booking services from Pune to Shirdi.',
  },
  {
    question: 'How can I book a corporate cab from Pune to Shirdi with Aaryan Travels?',
    answer: 'You can book a corporate cab through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate travel from Pune to Shirdi?',
    answer: 'We offer a fleet of well-maintained sedans, SUVs, and premium cars suitable for executive and team travel.',
  },
  {
    question: 'Is Pune to Shirdi corporate cab booking available for both one-way and round trips?',
    answer: 'Yes, Aaryan Travels provides both one-way and round-trip options for corporate cab bookings from Pune to Shirdi.',
  },
  {
    question: 'Are the drivers trained and professional for corporate cab travel to Shirdi?',
    answer: 'Absolutely. Our drivers are trained, punctual, and experienced with corporate travel protocols and the Pune-Shirdi route.',
  },
  {
    question: 'Can Aaryan Travels handle bulk corporate cab bookings for events in Shirdi?',
    answer: 'Yes, we manage group and bulk cab bookings for corporate meetings, retreats, or events in Shirdi.',
  },
  {
    question: 'Do you offer invoicing and monthly billing for Pune to Shirdi corporate cab bookings?',
    answer: 'Yes, we provide GST-compliant invoicing and flexible monthly billing options for corporate clients.',
  },
  {
    question: 'Is the Pune to Shirdi corporate cab service available 24x7?',
    answer: 'Yes, Aaryan Travels offers round-the-clock service for corporate cab bookings between Pune and Shirdi.',
  },
  {
    question: 'What safety measures are followed during Pune to Shirdi corporate cab travel?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'Can pickup and drop locations be customized for Pune to Shirdi corporate cab bookings?',
    answer: 'Yes, we allow full customization of pickup and drop-off points as per your corporate travel requirements.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Bhandari',
    feedback: 'Aaryan Travels provided excellent corporate cab service for our Pune to Shirdi trip. Professional and reliable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shraddha Menon',
    feedback: 'Very smooth booking and travel experience for our corporate team’s Pune to Shirdi visit. Highly recommend Aaryan Travels.',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Corporate Cab Booking",
  "image": "https://aaryantravels.com/assets/images/pune-shirdi-corporate-cab.jpg", // replace with actual image URL
  "description": "Affordable and reliable corporate cab booking from Pune to Shirdi by Aaryan Travels. Perfect for business travel, staff transport, and executive rides with sedan and SUV options. Book online for seamless corporate cab services.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "2700", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1900",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/pune-to-shirdi-corporate-cab-booking"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Shirdi Corporate Cab Booking | Business Taxi Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Affordable and reliable corporate cab booking from Pune to Shirdi by Aaryan Travels. Perfect for business travel, staff transport, and executive rides with sedan and SUV options. Book online for seamless corporate cab services."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Corporate Cab Booking, Corporate Taxi Pune Shirdi, Business Cab Pune to Shirdi, Chauffeur Corporate Cab Pune to Shirdi, Office Cab Pune Shirdi, Outstation Corporate Cab Pune Shirdi, Affordable Pune to Shirdi Corporate Taxi, Online Corporate Cab Booking Pune Shirdi, Staff Transport Pune Shirdi, Premium Corporate Sedan Pune to Shirdi, SUV for Corporate Travel Pune Shirdi, Pune to Shirdi Business Travel Cab, One Way Corporate Cab Pune Shirdi, Round Trip Cab Pune Shirdi, Pune to Shirdi Executive Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicorporate;